import { useId } from "react";

import style from "./style.module.scss";
import type { ControlBaseProps } from "../../types";

function ControlBase({ label, children, touched, error }: ControlBaseProps) {
  const id = useId();

  return (
    <div className={style.container}>
      <label className={style.label} htmlFor={id}>
        {label}
      </label>
      <div className={style.field}>{children(id)}</div>
      {touched && error && <div className={style.error}>{error}</div>}
    </div>
  );
}

export default ControlBase;
